module.exports = __webpack_public_path__ + "img/4002800.f48d90e0.svg";